import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/view.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view [<package-spec>] [<field>[.subfield]...]

aliases: info, show, v
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/view.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command shows data about a package and prints it to stdout.`}</p>
    <p>{`As an example, to view information about the `}<inlineCode parentName="p">{`connect`}</inlineCode>{` package from the registry, you would run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view connect
`}</code></pre>
    <p>{`The default version is `}<inlineCode parentName="p">{`"latest"`}</inlineCode>{` if unspecified.`}</p>
    <p>{`Field names can be specified after the package descriptor.
For example, to show the dependencies of the `}<inlineCode parentName="p">{`ronn`}</inlineCode>{` package at version
`}<inlineCode parentName="p">{`0.3.5`}</inlineCode>{`, you could do the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view ronn@0.3.5 dependencies
`}</code></pre>
    <p>{`You can view child fields by separating them with a period.
To view the git repository URL for the latest version of `}<inlineCode parentName="p">{`npm`}</inlineCode>{`, you would run the following command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view npm repository.url
`}</code></pre>
    <p>{`This makes it easy to view information about a dependency with a bit of
shell scripting. For example, to view all the data about the version of
`}<inlineCode parentName="p">{`opts`}</inlineCode>{` that `}<inlineCode parentName="p">{`ronn`}</inlineCode>{` depends on, you could write the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view opts@$(npm view ronn dependencies.opts)
`}</code></pre>
    <p>{`For fields that are arrays, requesting a non-numeric field will return
all of the values from the objects in the list. For example, to get all
the contributor email addresses for the `}<inlineCode parentName="p">{`express`}</inlineCode>{` package, you would run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view express contributors.email
`}</code></pre>
    <p>{`You may also use numeric indices in square braces to specifically select
an item in an array field. To just get the email address of the first
contributor in the list, you can run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view express contributors[0].email
`}</code></pre>
    <p>{`Multiple fields may be specified, and will be printed one after another.
For example, to get all the contributor names and email addresses, you
can do this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view express contributors.name contributors.email
`}</code></pre>
    <p>{`"Person" fields are shown as a string if they would be shown as an
object.  So, for example, this will show the list of `}<inlineCode parentName="p">{`npm`}</inlineCode>{` contributors in
the shortened string format.  (See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-json"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` for more on this.)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view npm contributors
`}</code></pre>
    <p>{`If a version range is provided, then data will be printed for every
matching version of the package.  This will show which version of `}<inlineCode parentName="p">{`jsdom`}</inlineCode>{`
was required by each matching version of `}<inlineCode parentName="p">{`yui3`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view yui3@'>0.5.4' dependencies.jsdom
`}</code></pre>
    <p>{`To show the `}<inlineCode parentName="p">{`connect`}</inlineCode>{` package version history, you can do
this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm view connect versions
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`Output`}</h3>
    <p>{`If only a single string field for a single version is output, then it
will not be colorized or quoted, to enable piping the output to
another command. If the field is an object, it will be output as a JavaScript object literal.`}</p>
    <p>{`If the `}<inlineCode parentName="p">{`--json`}</inlineCode>{` flag is given, the outputted fields will be JSON.`}</p>
    <p>{`If the version range matches multiple versions then each printed value
will be prefixed with the version it applies to.`}</p>
    <p>{`If multiple fields are requested, then each of them is prefixed with
the field name.`}</p>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-search"
        }}>{`npm search`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-docs"
        }}>{`npm docs`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      